(function () {
  function initOne(root) {
    if (!root || root.dataset.cmcInit === 'true') return;
    root.dataset.cmcInit = 'true';

    var track = root.querySelector('.cmc-track');
    var prevBtn = root.querySelector('.cmc-arrow-prev');
    var nextBtn = root.querySelector('.cmc-arrow-next');
    var dotsWrap = root.querySelector('.cmc-dots');
    if (!track) return;

    function slideWidth() {
      var slide = track.querySelector('.cmc-slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap || 0);
      return slide.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function buildDots() {
      if (!dotsWrap) return;
      var slides = track.querySelectorAll('.cmc-slide');
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cmc-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: slideWidth() * i, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll('.cmc-dot');
      var index = Math.round(track.scrollLeft / slideWidth());
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateArrows();
        updateDots();
        ticking = false;
      });
    });

    // Drag-to-scroll for desktop mouse users
    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX;
      startScroll = track.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var walk = e.pageX - startX;
      track.scrollLeft = startScroll - walk;
    });

    window.addEventListener('resize', function () {
      updateArrows();
      updateDots();
    });

    buildDots();
    updateArrows();
  }

  window.initCmcCarousel = function (root) {
    initOne(root);
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cmc-section').forEach(initOne);
  });
})();